const VetIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" viewBox="0 0 20 20">
	<path d="M0 0h20v20H0z" fill="none" />
	<path fill="currentColor" d="M7 17H6a3 3 0 0 1-3-3v-1h4zm10-3a3 3 0 0 1-3 3H8v-4h9zm-5-2H3V6a3 3 0 0 1 3-3h6zm5 0h-4V8h4zm-3-9a3 3 0 0 1 3 3v1h-4V3z" />
</svg>

  );
};

export default VetIcon;
